import {
  Box,
  Button,
  CircularProgress,
  Grid2 as Grid,
  Stack,
} from "@mui/material";
import { updatePasswordReq } from "../../../redux/member-slices/auth.slice";
import { updatePasswordSchema } from "../../../utils/velidations";
import { useDispatch, useSelector } from "react-redux";
import InputFieldB from "../../ui/InputFieldB";
import { useState } from "react";

function Password() {
  const dispatch = useDispatch();
  const [helperText, setHelperText] = useState([]);
  const { other } = useSelector((state) => state.memberSlice);

  // handle change password
  const handleUpdatePassword = (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    const formData = Object.fromEntries(form);
    const result = updatePasswordSchema.safeParse(formData);
    if (!result.success) {
      const groupedErrors = {};
      result.error.issues.forEach((issue) => {
        const key = issue.path[0];
        if (!groupedErrors[key]) {
          groupedErrors[key] = [];
        }
        groupedErrors[key].push(issue.message);
      });
      setHelperText(groupedErrors);
      return;
    }
    setHelperText([]);
    dispatch(updatePasswordReq(formData))
      .unwrap()
      .then(() => {
        e.target.reset();
      })
      .catch(() => {});
  };

  return (
    <Box
      sx={{
        p: 3,
        height: "100%",
        bgcolor: "white",
        borderRadius: "8px",
      }}
    >
      <Grid container>
        <Grid size={{ xs: 12, lg: 8, xl: 5 }}>
          <Stack spacing={3} component="form" onSubmit={handleUpdatePassword}>
            <InputFieldB
              type="password"
              label="old password"
              placeholder="Enter your old password"
              name="currentPassword"
              inputtype="InputFieldB"
              helperText={helperText}
            />
            <InputFieldB
              name="password"
              type="password"
              label="new password"
              placeholder="Enter your new password"
              inputtype="InputFieldB"
              helperText={helperText}
            />
            <InputFieldB
              type="password"
              name="confPassword"
              label="confirm password"
              placeholder="Enter your confirm password"
              inputtype="InputFieldB"
              helperText={helperText}
            />
            <Button
              sx={{
                fontSize: "18px",
                justifyContent: "center",
              }}
              type="submit"
              variant="contained"
              endIcon={
                other?.loadingLogin && (
                  <CircularProgress size={22} color="text" thickness={6} />
                )
              }
            >
              Update password
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Password;
